/**
 * Created by zhangrp on 2018/8/28.
 */
import api from './index';

let exports = {};

exports.isMerchtAuditBpConfAvailable = function (data/*bizTypeCode：审批业务类型，必传*/, callback) {   // 获取是否有可用的审批业务流程配置
    api.post('/oa/audit/bp/conf/available/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getMerchtAuditBpRecs = function (data, callback) {   // 获取商户审批业务流程记录列表
    api.post('/oa/audit/mercht/audit/bp/rec/list/get')
    .data(data)
    .done(callback)
    .go();
};


export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/oaAudit.js
// module id = 3496
// module chunks = 1